import { FC } from "react";

interface SearchListingsProps {
  width?: number;
  height?: number;
  fillColor?: string;
}

const SearchListings: FC<SearchListingsProps> = ({ width = 35, height = 36, fillColor = "#51C2B9" }) => {
  return (
    <>
      <svg
        className="min-w-35px"
        width={width}
        height={height}
        viewBox="0 0 35 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.2083 11.8945C10.2083 12.4468 9.76061 12.8945 9.20832 12.8945H3.91666C3.36437 12.8945 2.91666 12.4468 2.91666 11.8945V10.9779C2.91666 10.4256 3.36437 9.97786 3.91666 9.97786H9.20832C9.76061 9.97786 10.2083 10.4256 10.2083 10.9779V11.8945ZM10.2083 18.2695C10.2083 17.7172 9.76061 17.2695 9.20832 17.2695H3.91666C3.36437 17.2695 2.91666 17.7172 2.91666 18.2695V19.1862C2.91666 19.7385 3.36437 20.1862 3.91666 20.1862H9.20832C9.76061 20.1862 10.2083 19.7385 10.2083 19.1862V18.2695ZM30.7342 26.7708C30.3437 27.1613 29.7105 27.1613 29.32 26.7708L24.4417 21.8924C23.275 22.6508 21.9042 23.1029 20.4167 23.1029C16.3917 23.1029 13.125 19.8362 13.125 15.8112C13.125 11.7862 16.3917 8.51953 20.4167 8.51953C24.4417 8.51953 27.7083 11.7862 27.7083 15.8112C27.7083 17.2987 27.2562 18.6695 26.4979 19.8216L31.3781 24.7145C31.7677 25.1052 31.7673 25.7376 31.3771 26.1278L30.7342 26.7708ZM24.7917 15.8112C24.7917 13.4049 22.8229 11.4362 20.4167 11.4362C18.0104 11.4362 16.0417 13.4049 16.0417 15.8112C16.0417 18.2174 18.0104 20.1862 20.4167 20.1862C22.8229 20.1862 24.7917 18.2174 24.7917 15.8112ZM2.91666 26.4779C2.91666 27.0301 3.36437 27.4779 3.91666 27.4779H16.5C17.0523 27.4779 17.5 27.0301 17.5 26.4779V25.5612C17.5 25.0089 17.0523 24.5612 16.5 24.5612H3.91666C3.36437 24.5612 2.91666 25.0089 2.91666 25.5612V26.4779Z"
          fill={fillColor}
        />
      </svg>
    </>
  );
};

export default SearchListings;